import qs from 'qs';
import { network } from 'services/network';

export const saveFilterBulkAssignTags = (params) => {
    const querystring = qs.stringify(params.querystring, { addQueryPrefix: true, skipNulls: true });
    return network.post(`api/bo/saveFilterBulkAssignTags${querystring}`, params.body).then((response) => {
        return response.data;
    });
};
